import BreadcrumbListData, {
  BreadcrumbListProps,
  ItemElementType
} from '@anm/components/structures/BreadcrumbList';
import { getBreadcrumbsData } from '@anm/components/templates/CategoryBreadcrumbs';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { templateSelectors } from '../../../store/modules/template';

import { getPageLink } from './helpers';

const TemplateBreadcrumbListSchema: FC = () => {
  const pageName = useSelector(templateSelectors.selectTemplatePage);

  const breadcrumbsData = getBreadcrumbsData(pageName);

  const lastIndex = breadcrumbsData.length - 1;

  const itemListElement = breadcrumbsData.map(({ name, page }, index) => ({
    name,
    position: index + 1,
    '@type': 'ListItem' as ItemElementType,
    ...(lastIndex !== index && { item: getPageLink(page) })
  }));

  const videoObjectProps: BreadcrumbListProps = {
    itemListElement
  };

  return <BreadcrumbListData {...videoObjectProps} />;
};

export default TemplateBreadcrumbListSchema;
